import { z } from "zod";

export const MeritFieldMapSchema = z.object({
  Email: z.string().optional(),
  "First Name": z.string(),
  "Issuing Org Name": z.string(),
  "Last Name": z.string(),
});
